import React, { useEffect, useState } from "react";
import { SimpleItem } from 'devextreme-react/form';
import { DateBox, NumberBox, TextBox } from "devextreme-react";
import { LVForm } from "../../../Basicos/LVForm";
import ComboAbmConCuentasFinancierasTipos from "../../Combos/ComboAbmConCuentasFinancierasTipos";
import ComboAbmConCuentasFinancieras from "../../Combos/ComboAbmConCuentasFinancieras";
import ComboVenAnticipos from "../../Combos/ComboVenAnticipos";
import ComboComAnticipos from "../../Combos/ComboComAnticipos";
import ComboConChequesDeTercerosUsables from "../../Combos/ComboConChequesDeTercerosUsables";
import LVButtonAccion from "../../../Basicos/LVButtonAccion";
import { LVGridCarga } from "../../../Basicos/LVGridCarga";
import { Column, Pager, Paging } from "devextreme-react/data-grid";
import { useCallback } from "react";
import { function_ABM_CON_CuentasFinancieras_Leer } from "neftis7_apicaller/src/funciones/ABM/CONT/ABM_CON_CuentasFinancieras";
import { function_ABM_CON_Monedas_Leer } from "neftis7_apicaller/src/funciones/ABM/CONT/ABM_CON_Monedas";
import { function_CON_Cheques_Leer } from "neftis7_apicaller/src/funciones/CONT/CON_Cheques";
import { function_COM_Pagos_Anticipos_Leer } from "neftis7_apicaller/src/funciones/COM/Pagos/COM_Pagos_Anticipos";
import { function_VEN_Recibos_Anticipos_Leer } from "neftis7_apicaller/src/funciones/VEN/Recibos/VEN_Recibos_Anticipos";

function LVFormasDePago({ EsPago = false, EsRecibo = false, ImporteTotal = 0, IdEEX,
  onTotalImporteDelComponenteChange, DatosFormasPago, setDatosFormasPago }) {

  const [reloadCF, setReloadCF] = useState(false);
  const [codigoCuentaFinanciera, setCodigoCuentaFinanciera] = useState("");
  const [cuentaFinanciera, setCuentaFinanciera] = useState("");
  const [idTipoCuentaFinanciera, setIdTipoCuentaFinanciera] = useState(0);

  const [comprobante, setComprobante] = useState("");
  const [importe, setImporte] = useState(0);
  const [banco, setBanco] = useState("");
  const [cuotas, setCuotas] = useState(1);
  const [cheque, setCheque] = useState("");
  const [fechaCompromiso, setFechaCompromiso] = useState(new Date());
  const [idAnticipoCompra, setIdAnticipoCompra] = useState(0);
  const [idAnticipoVenta, setIdAnticipoVenta] = useState(0);
  const [idCheque, setIdCheque] = useState(0);
  const [contadorId, setContadorId] = useState(1);
  const [gridDataSource, setGridDataSource] = useState([]);
  const [totales, setTotales] = useState("TOTAL: $0");
  const [total, setTotal] = useState(0);
  const [resto, setResto] = useState(0);
  const [codigoMoneda, setCodigoMoneda] = useState("PA");
  const [cotizacion, setCotizacion] = useState(1);

  const objetoParaAgregar = {
    IdTipoCuentaFinanciera: idTipoCuentaFinanciera,
    CodigoCuentaFinanciera: codigoCuentaFinanciera,
    CuentaFinanciera: cuentaFinanciera,
    CodigoCompania: localStorage.getItem("CodigoCompania"),
    CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
    CodigoPlanta: localStorage.getItem("CodigoPlanta"),
    Importe: importe,
    Comprobante: comprobante,
    CodigoMoneda: codigoMoneda,
    Cotizacion: cotizacion,
    CantidadCuotas: cuotas,
    Banco: banco,
    NumeroCheque: cheque,
    FechaCompromiso: fechaCompromiso,
    IdAnticipoVenta: idAnticipoVenta,
    IdAnticipoCompra: idAnticipoCompra,
    IdCheque: idCheque
  };

  const isVisible = (field) => {

    if (idTipoCuentaFinanciera === 0) {
      return field === "nada";
    }
    //Efectivo
    if (idTipoCuentaFinanciera === 1) {
      return field === "importe" || field === "cuentaFinanciera";
    }
    //Bancos
    if (idTipoCuentaFinanciera === 2) {
      return field === "importe" || field === "comprobante" || field === "cuentaFinanciera";
    }
    //Tarjetas Crédito 
    if (idTipoCuentaFinanciera === 3) {
      return field === "importe" || field === "cuotas" || field === "cuentaFinanciera";
    }
    //Cheque Propio 
    if (idTipoCuentaFinanciera === 1000) {
      return field === "importe" || field === "fechaCompromiso" || field === "cuentaFinanciera" || field === "cheque";
    }
    //Cheque Tercero 
    if (idTipoCuentaFinanciera === 1100) {
      if (EsRecibo) {
        return field === "importe" || field === "fechaCompromiso" || field === "banco" || field === "cheque";
      }
      if (EsPago) {
        return field === "idCheque";
      }
    }
    //Anticipos
    if (idTipoCuentaFinanciera === 2000) {
      if (EsRecibo) {
        return field === "anticiposVenta";
      }
      if (EsPago) {
        return field === "anticiposCompra";
      }
    }
    return true;
  };

  const customizeTotal = useCallback((e) => {
    if (e.value) {
      const formattedValue = e.value;
      onTotalImporteDelComponenteChange(e.value);
      return `T: ${formattedValue}`;
    }
  }, []);

  const Totalizador = () => {
    let totalNeto = 0;

    gridDataSource.forEach(row => {
      totalNeto += row.Importe || 0;
    });

    onTotalImporteDelComponenteChange(totalNeto);

    setTotales(`TOTAL: $${totalNeto.toFixed(2)}`);

    setTotal(totalNeto)

    setResto(ImporteTotal - totalNeto)
  }

  const LimpiezazDeCampos = () => {
    setIdTipoCuentaFinanciera(0)
    setCodigoCuentaFinanciera("");
    setCuentaFinanciera("");
    setImporte(0);
    setComprobante("");
    setCuotas(1);
    setBanco("");
    setCheque("");
    setIdCheque(0);
    setFechaCompromiso(new Date());
    setIdAnticipoVenta(0);
    setIdAnticipoCompra(0);
  }

  const handleOnRowUpdatedLocal = async (e) => {
    const updatedRow = e.data;
    const Importe = updatedRow.Importe

    Totalizador()
  };

  const handleOnValueChangedChequesTerceros = async (e) => {
    setIdCheque(e.value);

    const resultCheque = await function_CON_Cheques_Leer(e.value)

    if (resultCheque) {
      setCodigoCuentaFinanciera("");
      setCuentaFinanciera("");
      setImporte(resultCheque.data[0].Importe);
      setComprobante("");
      setCuotas(1);
      setBanco(resultCheque.data[0].Banco);
      setCheque(resultCheque.data[0].Numero);
      setIdCheque(resultCheque.data[0].IdCheque)
      setFechaCompromiso(resultCheque.data[0].FechaPagoCompromiso);
      setIdAnticipoVenta(0);
      setIdAnticipoCompra(0);
    }
    else {
      LimpiezazDeCampos()
    }
  };

  const handleOnValueChangedAnticiposPagos = async (e) => {
    setIdAnticipoCompra(e.value)

    const resultAnticipo = await function_COM_Pagos_Anticipos_Leer(e.value)

    if (resultAnticipo) {
      setCodigoCuentaFinanciera("");
      setCuentaFinanciera("");
      setImporte(resultAnticipo.data[0].Importe);
      setComprobante("");
      setCuotas(1);
      setBanco("");
      setCheque("");
      setIdCheque(0)
      setFechaCompromiso(new Date());
      setIdAnticipoVenta(0);
      setIdAnticipoCompra(e.value);
    }
    else {
      LimpiezazDeCampos()
    }
  };

  const handleOnValueChangedAnticiposRecibos = async (e) => {
    setIdAnticipoVenta(e.value)

    const resultAnticipo = await function_VEN_Recibos_Anticipos_Leer(e.value)

    if (resultAnticipo) {
      setCodigoCuentaFinanciera("");
      setCuentaFinanciera("");
      setImporte(resultAnticipo.data[0].Importe);
      setComprobante("");
      setCuotas(1);
      setBanco("");
      setCheque("");
      setIdCheque(0)
      setFechaCompromiso(new Date());
      setIdAnticipoVenta(e.value);
      setIdAnticipoCompra(0);
    }
    else {
      LimpiezazDeCampos()
    }
  };

  const handleOnValueChangedCuentasFinancierasTipos = async (e) => {
    LimpiezazDeCampos()

    setIdTipoCuentaFinanciera(e.value)

    if (e.value == 1000) {
      setIdCheque(-1)
    } else {
      setIdCheque(0)
    }
  }

  const handleAgregarOnClick = () => {
    if (isVisible("importe") && (!importe || importe <= 0)) {
      alert("El campo Importe es obligatorio y debe ser mayor a 0.");
      return false;
    }
    if (isVisible("cuentaFinanciera") && !codigoCuentaFinanciera) {
      alert("Debe seleccionar una Cuenta Financiera.");
      return false;
    }
    if (isVisible("comprobante") && !comprobante) {
      alert("El campo Comprobante es obligatorio.");
      return false;
    }
    if (isVisible("banco") && !banco) {
      alert("El campo Banco es obligatorio.");
      return false;
    }
    if (isVisible("cheque") && !cheque) {
      alert("El campo Cheque es obligatorio.");
      return false;
    }
    if (isVisible("fechaCompromiso") && !fechaCompromiso) {
      alert("Debe ingresar una Fecha de Compromiso.");
      return false;
    }

    if (isVisible("idCheque") && idCheque < 1) {
      alert("Debe ingresar un Cheque.");
      return false;
    }

    const objetoConId = { ...objetoParaAgregar, id: contadorId }; // Agregamos el campo id
    setGridDataSource([...gridDataSource, objetoConId]);
    setContadorId(contadorId + 1); // Incrementamos el contador

    LimpiezazDeCampos()

    Totalizador()
  };

  useEffect(() => {
    setReloadCF(true)
  }, [idTipoCuentaFinanciera]);

  useEffect(() => {
    Totalizador()

    setDatosFormasPago(gridDataSource)
  }, [gridDataSource]);

  useEffect(() => {
    Totalizador()
  }, [ImporteTotal]);

  return (
    <div className="LV-GroupBox-div LV-FlexContainer" style={{ display: 'flex', flexDirection: 'column', height: '525px', width: '100%' }}>
      <ComboAbmConCuentasFinancierasTipos ancho="500" value={idTipoCuentaFinanciera}
        onValueChanged={handleOnValueChangedCuentasFinancierasTipos} esRecibo={EsRecibo} esPago={EsPago} />

      <ComboAbmConCuentasFinancieras IdTipoCuentaFinanciera={idTipoCuentaFinanciera} ancho="500" value={codigoCuentaFinanciera}
        onValueChanged={async (e) => {
          if (e.value && e.value != "") {
            if (idTipoCuentaFinanciera != 1100) {
              setCodigoCuentaFinanciera(e.value);
              setCuentaFinanciera(e.component.option("text"));

              const resultCF = await function_ABM_CON_CuentasFinancieras_Leer(e.value)
              setCodigoMoneda(resultCF.data[0].CodigoMoneda)
              const resultMoneda = await function_ABM_CON_Monedas_Leer(resultCF.data[0].CodigoMoneda)

              setCotizacion(resultMoneda.data[0].Cotizacion)
            }
          } else {
            setCodigoCuentaFinanciera("")
            setCuentaFinanciera("")
            setCodigoMoneda("")
            setCotizacion(1)
          }
        }}
        reloadData={reloadCF} visible={isVisible("cuentaFinanciera")} />

      <div style={{ display: "flex", alignItems: "center", marginBottom: "10px", gap: "20px" }}>
        <NumberBox
          label="Importe"
          value={importe}
          onValueChanged={(e) => setImporte(e.value)}
          visible={isVisible("importe")}
        />
        <LVButtonAccion
          Texto="RESTO"
          onClick={() => {
            setImporte(resto);
          }}
          style={{ marginLeft: "10px", height: "40px" }}
          visible={isVisible("importe")}
        />
      </div>

      <div style={{ display: "flex", alignItems: "center", marginBottom: "10px", gap: "20px" }}>
        <ComboConChequesDeTercerosUsables value={idCheque}
          onValueChanged={handleOnValueChangedChequesTerceros}
          visible={isVisible("idCheque")}
          ancho="400" />

        <TextBox
          label="Comprobante"
          value={comprobante} onValueChanged={(e) => setComprobante(e.value)} visible={isVisible("comprobante")} />
        <NumberBox
          label="Cuotas"
          value={cuotas} onValueChanged={(e) => setCuotas(e.value)} visible={isVisible("cuotas")} />
        <TextBox
          label="Banco"
          value={banco} onValueChanged={(e) => setBanco(e.value)} visible={isVisible("banco")} />
        <TextBox
          label="Cheque"
          value={cheque} onValueChanged={(e) => setCheque(e.value)} visible={isVisible("cheque")} />

        <DateBox displayFormat="dd/MM/yyyy" value={fechaCompromiso} onValueChanged={(e) => setFechaCompromiso(e.value)} width={120} visible={isVisible("fechaCompromiso")} />
      </div>

      <ComboVenAnticipos IdCliente={IdEEX} ancho="500" value={idAnticipoVenta} onValueChanged={handleOnValueChangedAnticiposRecibos} visible={isVisible("anticiposVenta")} />
      <ComboComAnticipos IdProveedor={IdEEX} ancho="500" value={idAnticipoCompra} onValueChanged={handleOnValueChangedAnticiposPagos} visible={isVisible("anticiposCompra")} />

      <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
        <LVButtonAccion Texto="AGREGAR" onClick={handleAgregarOnClick} style={{ marginTop: "10px" }} />
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', height: '20px' }}></div>

      <div style={{ display: 'flex', flexDirection: 'column', width: '100%', height: '300px', overflow: 'auto' }}>

        <LVGridCarga
          dataSource={gridDataSource}
          keyExpr="id"
          AnchoBotonera="38"
          allowEditing={true}
          onRowUpdated={handleOnRowUpdatedLocal}
          onRowRemoved={handleOnRowUpdatedLocal}
        >
          <Column caption="Orden" dataField="id" width="70" alignment="Right" visible={false} dataType="number" />
          <Column caption="Cuenta Financiera" alignment="Center">
            <Column caption="Tipo" dataField="idTipoCuentaFinanciera" width="80" alignment="Left" dataType="string" visible={false} allowEditing={false} />
            <Column caption="Código" dataField="CodigoCuentaFinanciera" width="70" alignment="Left" dataType="string" allowEditing={false} />
            <Column caption="Descripción" dataField="CuentaFinanciera" width="100%" minWidth="150" alignment="Left" dataType="string" allowEditing={false} />
          </Column>

          <Column caption="Comprobante" dataField="Comprobante" width="110" alignment="Left" dataType="string" allowEditing={true} />
          <Column caption="Importe" dataField="Importe" width="90" alignment="Right" dataType="number" format="currency" allowEditing={true} />
          <Column caption="Cuotas" dataField="CantidadCuotas" width="60" alignment="Right" dataType="number" allowEditing={true} />

          <Column caption="Cheque" alignment="Center">
            <Column caption="Banco" dataField="Banco" width="100" alignment="Left" dataType="string" allowEditing={true} />
            <Column caption="Cheque" dataField="NumeroCheque" width="100" alignment="Left" dataType="string" allowEditing={true} />
            <Column caption="F.Compromiso" dataField="FechaCompromiso" width="120" alignment="Left" dataType="date" allowEditing={true} format={'dd/MM/yyyy'} />
          </Column>
        </LVGridCarga>

        {totales}
      </div>
    </div>
  );
}

export default LVFormasDePago

